import { groupBy, update } from "lodash-es"
import { useTripStepGraph } from "graphql/trip/trip.hooks"
const useTripProgress = () => {
  const { data } = useTripStepGraph()

  const grouped = groupBy(data?.tripStepGraph, step => step?.layer)
  update(grouped, "MID", arr => {
    const grouped = groupBy(arr, mid => mid?.booking)
    return Object.values(grouped)
  })

  return grouped
}

export default useTripProgress
